<div class="profile-container">
    <div class="profile-content">
        <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                    <button title="{{ 'object-transit.requestSingleTransit' | translate }}"
                        (click)="setAddMode('single')" data-toggle="modal" data-target="#addTransitModal">
                        <i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}
                    </button>
                    <button title="{{ 'object-transit.requestBulkTransit' | translate }}" (click)="setAddMode('bulk')"
                        data-toggle="modal" data-target="#addTransitModal">
                        <i class="bi bi-layers"></i> {{ 'object-transit.bulkAdd' | translate }}
                    </button>
                    <button title="{{ 'generic.refresh' | translate }}" (click)="refreshAll()">
                        <i class="bi bi-arrow-clockwise"></i>
                    </button>
                </div>
            </div>

            <!-- Unified Transit Table -->
            <div class="mt-3">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 5%;">Id</th>
                            <th style="width: 20%;">{{ 'object-transit.assetName' | translate }}</th>
                            <th style="width: 10%;">{{ 'generic.status' | translate }}</th>
                            <th style="width: 18%;">{{ 'object-transit.fromLocation' | translate }}</th>
                            <th style="width: 18%;">{{ 'object-transit.toLocation' | translate }}</th>
                            <th style="width: 19%;">{{ 'object-transit.created' | translate }}</th>
                            <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' |
                                translate}}</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading && allTransitsList.length > 0">
                    <div class="data-view" id="{{objectTransit.transitId}}"
                        [ngClass]="{ 'delete-highlight': objectTransit.transitId == recordId }"
                        *ngFor="let objectTransit of allTransitsList | paginate: { itemsPerPage: tableSize, currentPage: pageNumber, totalItems: totalRecords }; let i = index">

                        <p style="width: 5%;">{{objectTransit.transitId || " -- " }}</p>
                        <p style="width: 20%;" title="{{ objectTransit.objectName }}">{{objectTransit.objectName ||
                            ('object-transit.bulkRequest' | translate) }}</p>
                        <p style="width: 10%;">{{objectTransit.status || " -- " }}</p>
                        <p style="width: 18%;">{{objectTransit.fromLocation || " -- " }}</p>
                        <p style="width: 18%;">{{objectTransit.toLocation || " -- " }}</p>
                        <p style="width: 19%;">{{objectTransit.createdDate | date:'dd/MM/yyyy HH:mm:ss'}}</p>
                        <p class="action-buttons" style="width: 10%;">
                            <i data-toggle="modal" title="{{ 'generic.view' | translate }}"
                                (click)="getObjectsTransitByObjectTransitId(objectTransit.transitId, isBulk(objectTransit) ? 'bulk' : 'single')"
                                [attr.data-target]="isBulk(objectTransit) ? '#viewBulkModal' : '#viewSingleModal'"
                                class="bi bi-eye-fill"></i>
                            <!-- <i title="{{ 'generic.edit' | translate }}" class="bi bi-pencil-square"
                                (click)="getObjectsTransitByObjectTransitId(objectTransit.transitId, isBulk(objectTransit) ? 'bulk' : 'single')"
                                data-toggle="modal" [attr.data-target]="isBulk(objectTransit) ? '#editBulkModal' : '#editSingleModal'"></i> -->
                            <i title="{{ 'generic.delete' | translate }}" class="bi bi-trash3"
                                (click)="deleteIdSelect(objectTransit.id, objectTransit)" data-toggle="modal"
                                data-target="#deleteModal"></i>
                        </p>
                    </div>
                </div>
            </div>

            <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && allTransitsList.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>{{ 'generic.noData' | translate }}</p>
                </div>
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
            </div>

            <!-- Unified Add Modal -->
            <div class="modal fade" id="addTransitModal" tabindex="-1" data-backdrop="static"
                aria-labelledby="addTransitModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="addTransitModalLabel">{{
                                'object-transit.headings.requestTransit' | translate }}
                                <span class="header-action" data-dismiss="modal">
                                    <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                                </span>
                            </h5>
                        </div>
                        <div class="modal-body">
                            <div [formGroup]="addObjectsTransitForm">
                                <div class="row">



                                    <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                                        <div class="form-group">
                                            <label>{{ 'object-transit.fromLocation' | translate }} <span
                                                    class="required">*</span></label>
                                            <select formControlName="fromLocation" class="form-control">
                                                <option [ngValue]="null" disabled selected hidden> -- Select Location --
                                                </option>
                                                <option value="{{location.zone}}"
                                                    *ngFor="let location of locationFilterList">
                                                    {{location.zone}} - {{location.city}} - {{location.postalCode}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12 mb-3">
                                        <div class="form-group">
                                            <label>{{ 'object-transit.toLocation' | translate }} <span
                                                    class="required">*</span></label>
                                            <select formControlName="toLocation" class="form-control">
                                                <option [ngValue]="null" disabled selected hidden> -- Select Location --
                                                </option>
                                                <ng-container *ngFor="let location of locationList">
                                                    <option value="{{location.zone}}"
                                                        *ngIf="location.zone !== addObjectsTransitForm.value.fromLocation">
                                                        {{location.zone}} - {{location.city}} - {{location.postalCode}}
                                                    </option>
                                                </ng-container>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="addMode === 'bulk'">
                                        <div class="form-group">
                                            <label>{{ 'object-transit.assets' | translate }} <span
                                                    class="required">*</span></label>
                                            <ng-multiselect-dropdown [placeholder]="'-- Select Assets --'"
                                                [settings]="assetDropdownSettings" [data]="objectInfoList"
                                                formControlName="objectInfoIds">
                                            </ng-multiselect-dropdown>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="addMode === 'single'">
                                        <div class="form-group">
                                            <label>{{ 'object-info.name' | translate }} <span
                                                    class="required">*</span></label>
                                            <select name="" id="" formControlName="objectInfoId" class="form-control">
                                                <option value="" disabled selected hidden> -- Select Asset --</option>
                                                <option value="{{object.objectInfoId}}"
                                                    *ngFor="let object of objectInfoList">
                                                    {{object.givenName}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 mb-3">
                                        <div class="form-group">
                                            <label>{{ 'generic.description' | translate }}</label>
                                            <textarea cols="30" rows="3" formControlName="description"
                                                class="form-control"
                                                placeholder="{{ 'generic.description' | translate }}"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" id="closeAddModalButton" (click)="closePopUp()"
                                    class="btn btn-secondary" data-dismiss="modal">
                                    {{ 'generic.cancel' | translate }}
                                </button>
                                <button type="button" (click)="addObjectTransit()" class="btn btn-primary">
                                    {{ 'generic.request' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Unified Delete Modal -->
            <div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static"
                aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                                <span class="header-action" data-dismiss="modal">
                                    <i class="bi bi-x-lg" (click)="clearData()"></i>
                                </span>
                            </h5>
                        </div>
                        <div class="modal-body">
                            <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?
                            </p>
                            <div class="modal-footer">
                                <button type="button" id="closeDeleteModalButton" (click)="clearData()"
                                    class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate
                                    }}</button>
                                <button type="button" (click)="deleteObjectTransit()" class="btn btn-primary">{{
                                    'generic.delete' |
                                    translate }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Edit Single Modal -->
            <div class="modal fade" id="editSingleModal" tabindex="-1" data-backdrop="static"
                aria-labelledby="editSingleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="editSingleModalLabel">{{
                                'object-transit.headings.editSingleTransit' | translate }}
                                <span class="header-action" data-dismiss="modal">
                                    <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                                </span>
                            </h5>
                        </div>
                        <div class="modal-body">
                            <div [formGroup]="editObjectsTransitForm">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="form-group">
                                            <label>{{ 'object-transit.transitId' | translate }} <span
                                                    class="required">*</span></label>
                                            <input type="text" formControlName="transitId" class="form-control"
                                                readonly>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="form-group">
                                            <label>{{ 'generic.status' | translate }} <span
                                                    class="required">*</span></label>
                                            <select formControlName="status" class="form-control">
                                                <option value="" disabled selected hidden> -- Select Status --</option>
                                                <option value="Requested">Requested</option>
                                                <option value="InTransit">In Transit</option>
                                                <option value="Transferred">Transferred</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="form-group">
                                            <label>{{ 'object-info.name' | translate }} <span
                                                    class="required">*</span></label>
                                            <input type="text" formControlName="objectName" class="form-control"
                                                readonly>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="form-group">
                                            <label>{{ 'object-transit.fromLocation' | translate }} <span
                                                    class="required">*</span></label>
                                            <select name="" id="" formControlName="fromLocation" class="form-control">
                                                <option [ngValue]="null" disabled selected hidden> -- Select Location --
                                                </option>
                                                <option value="{{location.zone}}"
                                                    *ngFor="let location of locationFilterList">
                                                    {{location.zone}} - {{location.city}} - {{location.postalCode}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="form-group">
                                            <label>{{ 'object-transit.toLocation' | translate }} <span
                                                    class="required">*</span></label>
                                            <select name="" id="" formControlName="toLocation" class="form-control">
                                                <option [ngValue]="null" disabled selected hidden> -- Select Location --
                                                </option>
                                                <ng-container *ngFor="let location of locationList">
                                                    <option value="{{location.zone}}"
                                                        *ngIf="location.zone !== editObjectsTransitForm.value.fromLocation">
                                                        {{location.zone}} - {{location.city}} - {{location.postalCode}}
                                                    </option>
                                                </ng-container>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="form-group">
                                            <label>{{ 'generic.description' | translate }}</label>
                                            <textarea name="" id="" cols="30" rows="3" formControlName="description"
                                                class="form-control"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" id="closeEditSingleModalButton" (click)="closePopUp()"
                                    class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate
                                    }}</button>
                                <button type="button" (click)="updateObjectsTransit()" class="btn btn-primary">{{
                                    'generic.save' |
                                    translate }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Edit Bulk Modal -->
            <div class="modal fade" id="editBulkModal" tabindex="-1" data-backdrop="static"
                aria-labelledby="editBulkModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="editBulkModalLabel">{{ 'object-transit.headings.editBulkTransit'
                                | translate }}
                                <span class="header-action" data-dismiss="modal">
                                    <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                                </span>
                            </h5>
                        </div>
                        <div class="modal-body">
                            <div [formGroup]="editBulkTransitForm">
                                <div class="row mb-3">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <div class="form-group">
                                            <label>{{ 'object-transit.bulkDescription' | translate }}</label>
                                            <input type="text" formControlName="description" class="form-control"
                                                placeholder="{{ 'object-transit.bulkDescription' | translate }}" />
                                        </div>
                                    </div>
                                </div>

                                <div formArrayName="objectTransitList">
                                    <div *ngFor="let item of editTransitArray.controls; let i = index"
                                        [formGroupName]="i" class="card mb-4 shadow-sm">
                                        <div class="card-body">
                                            <div
                                                class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                                                <h6 class="m-0 text-primary fw-bold">{{ 'object-transit.transitItem' |
                                                    translate }} {{i + 1}}</h6>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-6 col-md-6 col-sm-12">
                                                    <div class="form-group">
                                                        <label>{{ 'object-transit.transitId' | translate }} <span
                                                                class="required">*</span></label>
                                                        <input type="text" formControlName="transitId"
                                                            class="form-control" readonly>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-12">
                                                    <div class="form-group">
                                                        <label>{{ 'generic.status' | translate }} <span
                                                                class="required">*</span></label>
                                                        <select formControlName="status" class="form-control">
                                                            <option value="" disabled selected hidden> -- Select Status
                                                                --</option>
                                                            <option value="Requested">Requested</option>
                                                            <option value="InTransit">In Transit</option>
                                                            <option value="Transferred">Transferred</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                    <div class="form-group">
                                                        <label>{{ 'object-info.name' | translate }} <span
                                                                class="required">*</span></label>
                                                        <input type="text" formControlName="objectName"
                                                            class="form-control" readonly>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-12">
                                                    <div class="form-group">
                                                        <label>{{ 'object-transit.fromLocation' | translate }} <span
                                                                class="required">*</span></label>
                                                        <select name="" id="" formControlName="fromLocation"
                                                            class="form-control">
                                                            <option [ngValue]="null" disabled selected hidden> -- Select
                                                                Location --
                                                            </option>
                                                            <option value="{{location.zone}}"
                                                                *ngFor="let location of locationFilterList">
                                                                {{location.zone}} - {{location.city}} -
                                                                {{location.postalCode}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-lg-6 col-md-6 col-sm-12">
                                                    <div class="form-group">
                                                        <label>{{ 'object-transit.toLocation' | translate }} <span
                                                                class="required">*</span></label>
                                                        <select name="" id="" formControlName="toLocation"
                                                            class="form-control">
                                                            <option [ngValue]="null" disabled selected hidden> -- Select
                                                                Location --
                                                            </option>
                                                            <ng-container *ngFor="let location of locationList">
                                                                <option value="{{location.zone}}"
                                                                    *ngIf="location.zone !== item.value.fromLocation">
                                                                    {{location.zone}} - {{location.city}} -
                                                                    {{location.postalCode}}
                                                                </option>
                                                            </ng-container>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                    <div class="form-group">
                                                        <label>{{ 'generic.description' | translate }}</label>
                                                        <textarea name="" id="" cols="30" rows="3"
                                                            formControlName="description"
                                                            class="form-control"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" id="closeEditBulkModalButton" (click)="closePopUp()"
                                    class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate
                                    }}</button>
                                <button type="button" (click)="updateBulkObjectsTransit()" class="btn btn-primary">{{
                                    'generic.save'
                                    |
                                    translate }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- View Single Modal -->
            <div class="modal fade" id="viewSingleModal" tabindex="-1" data-backdrop="static"
                aria-labelledby="viewSingleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="viewSingleModalLabel">
                                {{ 'object-transit.headings.singleTransitDetail' | translate }}
                                <span data-dismiss="modal">
                                    <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                                </span>
                            </h5>
                        </div>

                        <div class="modal-body">
                            <div class="service-data" *ngIf="singleObjectsTransitData">
                                <div class="row">
                                    <div class="col-md-6 col-lg-6">
                                        <label>{{ 'object-transit.transitId' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.transitId || '--'}}</p>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <label>{{ 'generic.status' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.status || '--'}}</p>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <label>{{ 'object-info.name' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.objectName || '--'}}</p>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <label>{{ 'object-info.objectInfoId' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.objectInfoId || '--'}}</p>
                                    </div>

                                    <div class="col-md-12 col-lg-12 mt-3">
                                        <label>{{ 'generic.description' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.description || '--'}}</p>
                                    </div>

                                    <div class="col-lg-12 mt-3">
                                        <h6 class="section-title">{{ 'object-transit.fromLocationDetails' | translate }}
                                        </h6>
                                        <hr>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.country' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.fromCountry || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.provinceOrState' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.fromProvinceOrState || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.city' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.fromCity || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.zone' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.fromLocation || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.postalCode' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.fromPostalCode || '--'}}</p>
                                    </div>

                                    <div class="col-lg-12 mt-3">
                                        <h6 class="section-title">{{ 'object-transit.toLocationDetails' | translate }}
                                        </h6>
                                        <hr>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.country' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.toCountry || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.provinceOrState' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.toProvinceOrState || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.city' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.toCity || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.zone' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.toLocation || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.postalCode' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.toPostalCode || '--'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                *ngIf="singleObjectsTransitData?.status === 'Requested'"
                                (click)="rejectTransit('single')">{{ 'generic.reject' | translate }}</button>
                            <button type="button" class="btn btn-success"
                                *ngIf="singleObjectsTransitData?.status === 'Requested'"
                                (click)="statusUpdate('single', 'InTransit')">{{ 'generic.approve' | translate
                                }}</button>

                            <button type="button" class="btn btn-success"
                                *ngIf="singleObjectsTransitData?.status === 'InTransit'"
                                (click)="receiveTransit('single')">{{ 'generic.received' | translate }}</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                (click)="closePopUp()">{{
                                'generic.close' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- View Bulk Modal -->
            <div class="modal fade" id="viewBulkModal" tabindex="-1" data-backdrop="static"
                aria-labelledby="viewBulkModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="viewBulkModalLabel">
                                {{ 'object-transit.headings.bulkTransitDetail' | translate }}
                                <span data-dismiss="modal">
                                    <i class="bi bi-x-lg" (click)="closePopUp()"></i>
                                </span>
                            </h5>
                        </div>

                        <div class="modal-body">
                            <div class="service-data" *ngIf="singleObjectsTransitData">
                                <div class="row">
                                    <div class="col-md-6 col-lg-6">
                                        <label>{{ 'object-transit.transitId' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.transitId || '--'}}</p>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <label>{{ 'generic.status' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.status || '--'}}</p>
                                    </div>

                                    <div class="col-md-12 col-lg-12 mt-3">
                                        <label>{{ 'generic.description' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.description || '--'}}</p>
                                    </div>

                                    <div class="col-lg-12 mt-3">
                                        <h6 class="section-title">{{ 'object-transit.fromLocationDetails' | translate }}
                                        </h6>
                                        <hr>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.country' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.fromCountry || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.provinceOrState' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.fromProvinceOrState || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.city' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.fromCity || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.zone' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.fromLocation || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.postalCode' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.fromPostalCode || '--'}}</p>
                                    </div>

                                    <div class="col-lg-12 mt-3">
                                        <h6 class="section-title">{{ 'object-transit.toLocationDetails' | translate }}
                                        </h6>
                                        <hr>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.country' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.toCountry || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.provinceOrState' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.toProvinceOrState || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.city' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.toCity || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.zone' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.toLocation || '--'}}</p>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <label>{{ 'object-info.postalCode' | translate }} :</label>
                                        <p>{{singleObjectsTransitData.toPostalCode || '--'}}</p>
                                    </div>

                                    <div class="col-lg-12 mt-4"
                                        *ngIf="singleObjectsTransitData.objectTransitList && singleObjectsTransitData.objectTransitList.length > 0">
                                        <h6 class="section-title">{{ 'object-transit.assetsInTransit' | translate }}
                                        </h6>
                                        <table class="table table-striped table-bordered mt-2">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;"
                                                        *ngIf="singleObjectsTransitData.status === 'Requested'">
                                                        <input type="checkbox" (change)="toggleAllAssets($event)">
                                                    </th>
                                                    <th>{{ 'object-info.objectInfoId' | translate }}</th>
                                                    <th>{{ 'object-info.name' | translate }}</th>
                                                    <th>{{ 'generic.status' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of singleObjectsTransitData.objectTransitList">
                                                    <td *ngIf="singleObjectsTransitData.status === 'Requested'">
                                                        <input type="checkbox" [checked]="item.selected"
                                                            (change)="toggleSelection(item, $event)">
                                                    </td>
                                                    <td>{{item.objectInfoId || '--'}}</td>
                                                    <td>{{item.objectName || '--'}}</td>
                                                    <td>{{item.status || '--'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                *ngIf="singleObjectsTransitData?.status === 'Requested'"
                                (click)="rejectTransit('bulk')">{{ 'generic.rejectAll' | translate }}</button>
                            <button type="button" class="btn btn-success"
                                *ngIf="singleObjectsTransitData?.status === 'Requested'"
                                (click)="statusUpdate('bulk', 'InTransit')">{{ 'generic.approve' | translate }}</button>

                            <button type="button" class="btn btn-success"
                                *ngIf="singleObjectsTransitData?.status === 'InTransit'"
                                (click)="receiveTransit('bulk')">{{ 'generic.received' | translate }}</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                (click)="closePopUp()">{{
                                'generic.close' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>